<p-card>
  <header class="demo-brand">
    <h1>Acceso de demostración</h1>
    <p>Escanea el código desde la App de comerciales</p>
  </header>

  <canvas #qrCanvas class="demo-qr" aria-label="Código QR de acceso de demostración"></canvas>
  <p class="demo-ttl">Válido durante {{ secondsLeft }} segundos</p>
  <p-button
    type="button"
    label="Nuevo código"
    severity="secondary"
    [outlined]="true"
    (onClick)="newQr()"
    [disabled]="busy"
  />

  <hr />

  <form [formGroup]="codeForm" (ngSubmit)="redeem()">
    <label for="demo-code">Código de 6 dígitos</label>
    <input
      pInputText
      id="demo-code"
      class="w-100"
      formControlName="code"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="6"
    />
    <p-button
      type="submit"
      label="Entrar con código"
      class="w-100 mt-3"
      [style]="{ width: '100%' }"
      [disabled]="busy"
    />
  </form>

  @if (error) {
    <p-message styleClass="mt-3" severity="error">{{ error }}</p-message>
  }

  <a class="demo-back" routerLink="/login">Volver al acceso</a>
</p-card>
